import { render } from "./MainVideo.vue?vue&type=template&id=eb6403de&scoped=true"
import script from "./MainVideo.vue?vue&type=script&lang=js"
export * from "./MainVideo.vue?vue&type=script&lang=js"

import "./MainVideo.vue?vue&type=style&index=0&id=eb6403de&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb6403de"]])

export default __exports__